import MailOutlineIcon from '@mui/icons-material/MailOutline';
import Avatar from '@mui/material/Avatar';
import Badge from '@mui/material/Badge';
import Button from '@mui/material/Button';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useThreads } from '../../contexts/ThreadsContext';
import { Inbox } from '../messaging/Inbox';

export const InboxWidget = () => {
  const { threads, refreshThreads } = useThreads();
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState<boolean>(false);

  const unreadThreadsCount = threads.filter((thread) => thread.unreadCount > 0).length;

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleThreadOpen = (threadId: number) => {
    handleClose();
    navigate(`/messages/${threadId}`);
  };

  return (
    <>
      <Button onClick={handleOpen} sx={{ color: 'white' }} size="large" disabled={location.pathname.includes('/messages')}>
        <Badge badgeContent={unreadThreadsCount > 0 ? unreadThreadsCount : null} color="error">
          <Avatar alt="inbox">
            <MailOutlineIcon />
          </Avatar>
        </Badge>
      </Button>
      <Inbox
        open={open}
        threads={threads}
        mode={'widget'}
        onClose={handleClose}
        onNewMessage={async (newMessage, threadId) => {
          await refreshThreads();
        }}
        openThread={handleThreadOpen}
      />
    </>
  );
};
